export default "__VITE_ASSET__BE6N11Su__"